import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/domain.entity.ts
var createDomain = (value) => deepMerge({
	id: uuid25(),
	name: "",
	category: "",
	dataType: "",
	description: "",
	order: ""
}, value ?? {});
//#endregion
export { createDomain };
